import React from 'react'
import { Upload } from 'antd'
import { CustomButton } from './CustomButton'
import { UploadOutlined } from '@ant-design/icons'

export const CustomUpload = ({ children, ...props }) => {
  return (
    <Upload {...props}>
      {children || (
        <CustomButton style={{ fontSize: '12px' }}>
          <UploadOutlined /> Select File
        </CustomButton>
      )}
    </Upload>
  )
}